module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-5.9e6719c6.svg";